module.exports = __webpack_public_path__ + "static/img/5616_phase_function_Paper_Points.8c32f29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5616_phase_function_Paper_Points.png
// module id = I4C+
// module chunks = 0